namespace GeniuzPOS.AdvPromo {
    export class Adv05ItemExDtColumns {
        static columnsKey = 'AdvPromo.Adv05ItemExDt';
    }
}
